import { render, staticRenderFns } from "./RtcCallStarting.vue?vue&type=template&id=ce86a172&scoped=true"
import script from "./RtcCallStarting.vue?vue&type=script&lang=js"
export * from "./RtcCallStarting.vue?vue&type=script&lang=js"
import style0 from "./RtcCallStarting.vue?vue&type=style&index=0&id=ce86a172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce86a172",
  null
  
)

export default component.exports